import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { Ag1ButtonBaseComponent } from '../ag1-button-base/ag1-button-base.component';
import { NgTemplateOutlet } from '@angular/common';
import { Ag1TooltipDirective } from '../../directives/tooltip.directive';
import { RouterLink } from '@angular/router';
import { SentenceCasePipe } from '../../pipes/sentence.pipe';

@Component({
  selector: 'ag1-link',
  templateUrl: './ag1-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgTemplateOutlet,
    Ag1TooltipDirective,
    RouterLink,
    SentenceCasePipe,
  ],
})
export class Ag1LinkComponent extends Ag1ButtonBaseComponent {
  // logic implemented inside Ag1ButtonBaseComponent
  readonly variant = input<'primary' | 'secondary'>('primary');

  readonly showLink = computed(() => !!this.routerLink() && !this.disabled());

  readonly showButton = computed(() => !this.routerLink() || this.disabled());
}
